/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_Create_TitleInputs */

const cs_deal_payments_create_title = /** @type {(inputs: Deal_Payments_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová platba`)
};

const en_deal_payments_create_title = /** @type {(inputs: Deal_Payments_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New payment`)
};

/**
* | output |
* | --- |
* | "New payment" |
*
* @param {Deal_Payments_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_create_title = /** @type {((inputs?: Deal_Payments_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_create_title(inputs)
	return cs_deal_payments_create_title(inputs)
});